<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-wallet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.684 6C44.964 6 46 6.848 46 7.895v32.21C46 41.152 44.963 42 43.684 42H4.316C3.036 42 2 41.152 2 40.105V7.895C2 6.848 3.037 6 4.316 6h39.368zM42 10H6v28h36v-6h-8a8 8 0 110-16h8v-6zm0 10h-8a4 4 0 000 8h8v-8zm-8 2a2 2 0 110 4 2 2 0 010-4z"/></svg>
</template>
<script>

export default {
  name: 'IconWallet',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
